module.exports = __webpack_public_path__ + "img/peiicon5.3deb7117.svg";